import PropTypes from "prop-types"
import { forwardRef } from "react"

import Button from "components/ui/button"
import Image from "components/ui/image"
import { cn } from "styles/utils"

export const GradientContainer = ({
  className = "",
  hideSlideShadow = false,
  ...props
}) => (
  <div
    className={cn(
      "tablet:px-0 tablet:after:hidden relative px-12",
      !hideSlideShadow &&
        "after:w-(--after-width) after:bg-(--background) after:absolute after:right-0 after:top-0 after:block after:h-full",
      className
    )}
    style={{
      "--after-width": "8%",
      "--background":
        "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #ffffff 95%)",
    }}
    {...props}
  />
)

GradientContainer.propTypes = {
  className: PropTypes.string,
  hideSlideShadow: PropTypes.bool,
}

export const OptionsLabel = ({ className = "", ...props }) => (
  <p className={cn("text-14 font-bold text-black", className)} {...props} />
)

OptionsLabel.propTypes = {
  className: PropTypes.string,
}

export const OptionsSlider = forwardRef(
  ({ className = "", modal, ...props }, ref) => (
    <div
      className={cn(
        "tablet:flex-wrap tablet:overflow-x-auto tablet:last:after:hidden flex overflow-y-hidden overflow-x-scroll",
        modal ? "justify-between" : "justify-start",
        className
      )}
      ref={ref}
      {...props}
    />
  )
)

OptionsSlider.displayName = "OptionsSlider"

OptionsSlider.propTypes = {
  className: PropTypes.string,
  modal: PropTypes.bool,
}

export const ChoiceOption = forwardRef(({ className = "", ...props }, ref) => (
  <Button
    className={cn("wizard-choice-option", className)}
    ref={ref}
    {...props}
  />
))

ChoiceOption.displayName = "ChoiceOption"

ChoiceOption.propTypes = {
  className: PropTypes.string,
}

export const OptionTitle = ({ className = "", ...props }) => (
  <p className={cn("text-grey-70 text-12 mx-2 my-8", className)} {...props} />
)

OptionTitle.propTypes = {
  className: PropTypes.string,
}

export const OptionPrice = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-11 tablet:text-12 tracking-half font-bold text-black",
      className
    )}
    {...props}
  />
)

OptionPrice.propTypes = {
  className: PropTypes.string,
}

export const OptionsSelect = ({ className, ...props }) => (
  <select className={cn("w-3/4 bg-white px-10 py-8", className)} {...props} />
)

OptionsSelect.propTypes = {
  className: PropTypes.string,
}

export const OptionImage = ({ className, ...props }) => (
  <Image
    className={cn("aspect-square", className)}
    height="40"
    width="40"
    {...props}
  />
)

OptionImage.propTypes = {
  className: PropTypes.string,
}

export const SkuIcon = ({ className = "", skuColor = "W", ...props }) => (
  <div
    className={cn(
      "tablet:mx-24 tablet:mb-8 bg-grey-20 mx-16 mb-8 mt-0 flex size-48 items-center justify-center rounded-full",
      skuColor === "Y" && "bg-sku-ky",
      skuColor === "R" && "bg-sku-kr",
      skuColor === "CE" && "bg-sku-cer text-white",
      skuColor === "W" && "bg-sku-kw",
      skuColor === "V" && "bg-grey-20 border-sku-ky border-8",
      skuColor === "YGP" && "bg-grey-20 border-5 border-sku-ky pr-1",
      className
    )}
    {...props}
  />
)

SkuIcon.propTypes = {
  className: PropTypes.string,
  skuColor: PropTypes.string,
}

export const ErrorBox = (props) => (
  <div
    className="text-sale text-14 mb-16 flex items-center rounded-sm bg-[#e3352a26] p-8"
    {...props}
  />
)
